<div>
    <message-header *ngIf="shouldDisplayMenus()"></message-header>
    <navbar *ngIf="shouldDisplayMenus()"></navbar>
    <main class="c-main"><router-outlet></router-outlet></main>
    <call-to-action></call-to-action>
</div>
